// Angular Imports
import { NgModule, ModuleWithProviders } from "@angular/core";

// This Module's Components
import { OnlineSessionComponent } from "./online-session.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxErrorsModule } from "@ultimate/ngxerrors";
import { CommonModule } from "@angular/common";
import { ComponentModule } from "../../../../components/component.module";
import { joinmeetingService } from "../../Communication/joinmeeting/joinmeeting/joinmeeting.service";
import { IxsCkeditorModule } from "../../../../components/ixs-ckeditor/ixs-ckeditor.module";

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxErrorsModule,
    CommonModule,
    ComponentModule,
    IxsCkeditorModule
  ],
  declarations: [OnlineSessionComponent],
  exports: [OnlineSessionComponent],
  providers: [joinmeetingService],
})
export class OnlineSessionModule { }



// WEBPACK FOOTER //
// ./src/app/shell/forms/shared-modals/online-session/online-session.module.ts